import { Directive, Input, OnInit } from "@angular/core";
import { NgbTooltip } from "@ng-bootstrap/ng-bootstrap";

@Directive({
    selector: "[appTooltip]",
    standalone: false,
    hostDirectives: [
        {
            directive: NgbTooltip,
            inputs: ['ngbTooltip: appTooltip', 'placement', 'container', 'triggers', 'autoClose', 'tooltipClass']
        }
    ]
})
export class TooltipDirective implements OnInit {
    constructor(private ngbTooltip: NgbTooltip) {
        // Set triggers in constructor BEFORE NgbTooltip initializes
        // This ensures event listeners are registered only for hover, not focus
        this.ngbTooltip.triggers = 'mouseover:mouseleave';
    }

    ngOnInit() {
        // Set default values if not overridden
        if (!this.ngbTooltip.tooltipClass) {
            this.ngbTooltip.tooltipClass = 'simple-white-tooltip';
        }
        if (!this.ngbTooltip.container) {
            this.ngbTooltip.container = 'body';
        }
        if (!this.ngbTooltip.placement) {
            this.ngbTooltip.placement = 'top';
        }
        // Only override triggers if not explicitly set in HTML
        if (!this.ngbTooltip.triggers || this.ngbTooltip.triggers === 'hover focus') {
            this.ngbTooltip.triggers = 'mouseover:mouseleave';
        }
        this.ngbTooltip.autoClose = true;
    }
}
